<template>
    <div>
        <div class="tixstock-tags-skeleton mt-5">
            <div v-for="index in 3" :key="index" class="tixstock-tags-box-skeleton">
                <div class="search-tag-skeleton"></div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'SkeletonHeader'
}
</script>
<style scoped>

.tixstock-tags-skeleton {
  position: relative;
  width: 100%;
  background: white;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}


.tixstock-tags-box-skeleton {
  display: flex;
  align-items: center;
  padding: 12px 8px;
  background: white;
}

.search-tag-skeleton {
  height: 16px;
  background: #e0e0e0;
  border-radius: 4px;
  width: 100px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    background-color: #f0f0f0;
  }
  50% {
    background-color: #e0e0e0;
  }
  100% {
    background-color: #f0f0f0;
  }
}

</style>